import produce from 'immer';

import { ExchangePassengersState } from '../types';
import {
	setPassengers,
	setPassengerSelect,
	SetPassengersAction,
	SetPassengerSelectAction,
	SetPassengerSelectPayload
} from './actions';

const initialState: ExchangePassengersState = {};

function passengersReducer(state = initialState, { type, payload }: SetPassengersAction | SetPassengerSelectAction) {
	return produce(state, draft => {
		switch (type) {
			case setPassengers.toString():
				Object.assign(draft, payload);
				break;
			case setPassengerSelect.toString():
				const actionPayload = payload as SetPassengerSelectPayload;
				const ids = Array.isArray(actionPayload.id) ? actionPayload.id : [actionPayload.id];

				ids.forEach(id => (draft[id] = actionPayload.selected));
				break;
		}
	});
}

export default passengersReducer;
